var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquareBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.505 0H21.51C26.595 0 30 3.57 30 8.88V21.1365C30 26.43 26.595 30 21.51 30H8.505C3.42 30 0 26.43 0 21.1365V8.88C0 3.57 3.42 0 8.505 0ZM14.1459 19.4855L21.2709 12.3605C21.7809 11.8505 21.7809 11.0255 21.2709 10.5005C20.7609 9.99047 19.9209 9.99047 19.4109 10.5005L13.2159 16.6955L10.5909 14.0705C10.0809 13.5605 9.24094 13.5605 8.73094 14.0705C8.22094 14.5805 8.22094 15.4055 8.73094 15.9305L12.3009 19.4855C12.5559 19.7405 12.8859 19.8605 13.2159 19.8605C13.5609 19.8605 13.8909 19.7405 14.1459 19.4855Z",
    fill: "#1D8BF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquareBlue);
export default __webpack_public_path__ + "static/media/tick-square-blue.851ba85d.svg";
export { ForwardRef as ReactComponent };